export default {
  toggleTableColumnVisibility: (
    { commit, getters },
    { column,
    table = 'retFlexColumns' }
  ) => {
    let columns = []
    if (table === 'retFlexColumns') {
      columns = [...getters.retFlexColumns]
    }
    if (table === 'subventionColumns') {
      columns = [...getters.subventionColumns]
    }
    columns.forEach(col => {
      if (col.key === column.key) {
        col.visible = !col.visible
      }
    })
    commit('setTableColumns', { columns: columns, table: table })
  },
  initializeRetFlexColumns: ({ commit, rootGetters }) => {
    if (!rootGetters['LoginStore/isImpersonating']) {
      commit('initializeRetFlexColumns')
    } else {
      commit('resetColumns')
    }
  },
  initializeSubventionColumns: ({ commit, getters, rootGetters }) => {
    if (!rootGetters['LoginStore/isImpersonating']) {
      commit('initializeSubventionColumns')
    } else {
      commit('resetColumns')
    }
  },
  clearStore: ({ commit }) => {
    commit('resetColumns')
  }
}
